import global from "./global.js";
import WeakIterable from "./utils/WeakIterable.js";

const d3 = global.d3;

// const log = global.log.getLogger("f_mtac.SVG");

const Layer = function (name, svg) {
    var view = d3.create("svg:g").attr("id", name);
    var view_node = view.node();
    var handlers = new WeakIterable();
    var rendered = false;
    Object.defineProperty(this, "name", {
        set: () => { },
        get: () => name
    });
    Object.defineProperty(this, "view", {
        set: () => { },
        get: () => view
    });
    Object.defineProperty(this, "view_node", {
        set: () => { },
        get: () => view_node
    });
    Object.defineProperty(this, "rendered", {
        set: () => { },
        get: () => rendered
    });
    const is_rendered = () => {
        if (view.attr("hidden")) {
            return;
        }
        rendered = true;
        for (let handler of handlers) {
            handler();
        }
    };
    const is_not_rendered = () => {
        rendered = false;
    };
    this.remove = () => {
        svg.root.selectAll(`g#${name}`).remove();
        is_not_rendered();
    };
    this.append = () => {
        this.remove();
        svg.root.append(() => view_node);
        is_rendered();
    };
    this.insert = (before) => {
        this.remove();
        svg.root.insert(() => view_node, `g#${before}`);
        is_rendered();
    };
    this.hide = () => {
        view.attr("hidden", true);
        is_not_rendered();
    };
    this.show = () => {
        view.attr("hidden", null);
        is_rendered();
    };
    this.on_render = (handler) => {
        handlers.add(handler);
    };
    this.off_render = (handler) => {
        handlers.delete(handler);
    };
};

const SVG = function (view) {
    var layers = {};
    var objects = new WeakIterable();
    this.root = d3.select(view.container).append("svg").style("z-index", 10);
    this.width = 0; this.height = 0;
    this.margin = { x: 0, y: 0 };
    this.defs = this.root.append("defs");

    this.layer_create = (name) => {
        let layer = new Layer(name, this);
        layers[name] = layer;
        return layer.view;
    };
    this.layer_get = (name) => {
        if (!(name in layers)) {
            throw `layer ${name} not found`;
        }
        return layers[name].view;
    };
    this.layer_detach = (name) => {
        if (!(name in layers)) {
            throw `layer ${name} not found`;
        }
        let layer = layers[name];
        layer.remove();
        return layer.view;
    };
    this.layer_append = (name) => {
        if (!(name in layers)) {
            throw `layer ${name} not found`;
        }
        let layer = layers[name];
        layer.append();
        return layer.view;
    };
    this.layer_insert = (name, before) => {
        if (!(name in layers)) {
            throw `layer ${name} not found`;
        }
        if (!(before in layers)) {
            throw `layer ${before} not found`;
        }
        let layer = layers[name];
        layer.insert(before);
        return layer.view;
    };
    this.layer_hide = (name) => {
        if (!(name in layers)) {
            throw `layer ${name} not found`;
        }
        let layer = layers[name];
        layer.hide();
    };
    this.layer_show = (name) => {
        if (!(name in layers)) {
            throw `layer ${name} not found`;
        }
        let layer = layers[name];
        layer.show();
    };
    this.layer_on_render = (name, handler) => {
        if (!(name in layers)) {
            throw `layer ${name} not found`;
        }
        layers[name].on_render(handler);
    };
    this.layer_off_render = (name, handler) => {
        if (!(name in layers)) {
            throw `layer ${name} not found`;
        }
        layers[name].off_render(handler);
    };
    this.layer_rendered = (name) => {
        return layers[name].rendered;
    };
    this.has_layer = function (name) {
        return (name in layers);
    };
    this.object_add = function (object) {
        return objects.add(object);
    };
    this.object_remove = function (object) {
        return objects.delete(object);
    };
    this.transform = function (state) {
        for (let object of objects) {
            object.transform(state);
        }
    };
    this.resize = function () {
        var {
            paddingTop: top,
            paddingLeft: left
        } = window.getComputedStyle(this.root.node(), null);
        this.width = view.width;
        this.height = view.height;
        this.margin.x = parseFloat(left.replace("px", ""));
        this.margin.y = parseFloat(top.replace("px", ""));
        for (let object of objects) {
            object.resize();
        }
    };
    this.resize();
};

global.app.bootstrap.register_module({
    name: "svg",
    deps: ["view", "tools"],
    init: () => {
        global.svg = new SVG(global.view);
        global.view.layer_add(global.svg);
    }
});

export default SVG;

